"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndicatorsContainer = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_select_1 = require("react-select");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Buttons_1 = require("../../Buttons");
var utils_1 = require("../../../utils");
exports.IndicatorsContainer = function (props) {
    var selectProps = props.selectProps;
    var expandableGroups = selectProps.expandableGroups, isGrouped = selectProps.isGrouped, setIsGrouped = selectProps.setIsGrouped, menuIsOpen = selectProps.menuIsOpen;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        expandableGroups && menuIsOpen && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StyledToggleContainer, { onMouseDown: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                } },
                react_1.default.createElement(Buttons_1.IconButton, { toggled: isGrouped, icon: "file_tree", onClick: function () {
                        setIsGrouped(!isGrouped);
                    }, customButtonSize: "12px", customIconSize: "16px" })),
            react_1.default.createElement(StyledSeparator, null))),
        react_1.default.createElement(StyledReactSelectIndicatorsContainer, tslib_1.__assign({}, props))));
};
exports.IndicatorsContainer.displayName = 'FOS_ReactSelect_IndicatorsContainer';
var StyledReactSelectIndicatorsContainer = styled_components_1.default(react_select_1.components.IndicatorsContainer)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var StyledToggleContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin-right: 0.8rem;\n"], ["\n  margin-right: 0.8rem;\n"])));
var StyledSeparator = styled_components_1.default.span(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  align-self: stretch;\n  background-color: ", ";\n  width: 1px;\n"], ["\n  align-self: stretch;\n  background-color: ", ";\n  width: 1px;\n"])), utils_1.theme.colors.elementDivider);
var templateObject_1, templateObject_2, templateObject_3;
